export default {
    state: {
        vacationInfo: 0,
    },

    action: {
        getVacationInfo() {
            return (dispatch, getState) => {
                const {mainVacation} = getState();
                return {vacationInfo: mainVacation.vacationInfo + 1};
            };

        }
    },

    reducer: {
        getVacationInfo(state, action, error) {
            if (!error) {
                return {
                    ...state,
                    ...action.payload,
                };
            }

            return {...state};
        }
    }
};
